import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 查询秘钥设置情况
 * @param customerId
 */
export function checkKeycode(customerId) {
  return request({
    url: cmsServerContext + '/keycode/checkKeycode/' + customerId,
    method: 'get'
  })
}

/**
 * 更新单个秘钥
 * @param customerId
 * @param key
 * @param value
 */
export function updateKeycode(customerId,key,value) {
  return request({
    url: cmsServerContext + '/keycode/updateKeycode',
    method: 'post',
    data:{customerId:customerId,key:key,value:value}
  })
}